import { render, staticRenderFns } from "./editTag.vue?vue&type=template&id=7bb8d258&scoped=true"
import script from "./editTag.vue?vue&type=script&lang=js"
export * from "./editTag.vue?vue&type=script&lang=js"
import style0 from "./editTag.vue?vue&type=style&index=0&id=7bb8d258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb8d258",
  null
  
)

export default component.exports